export const isApplicableIncentive = (
	incentive,
	paymentType,
	selectedPayment
) => {
	if (!selectedPayment?.incentiveIds?.includes(incentive.incentiveId)) {
		return false;
	}

	if (incentive?.financeMethod === 'All' && incentive?.cash !== 0) {
		return true;
	}

	return true;
};

export const showAsCashOffer = (incentive) => {
	return (
		incentive?.incentiveType?.toLowerCase() === 'customer cash' ||
		incentive?.termRebates?.incentiveTermRange?.some((rebate) => {
			return rebate?.customerCash !== 0;
		})
	);
};

export const getIncentivePrefix = (incentive, { paymentLabel = '' }) => {
	const lowerIncentiveType = incentive?.incentiveType?.toLowerCase() || '';
	const lowerPaymentType = paymentLabel.toLowerCase();

	if (showAsCashOffer(incentive)) {
		return 'Cash Offer';
	}

	if (lowerPaymentType === 'lease') {
		return 'Lease Offer';
	}

	if (lowerIncentiveType === 'finance') {
		return 'Finance Offer';
	}

	return 'Special Offer';
};
